import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

const selectCarriersListState = (state: RootState) => state.carriersList;

export const selectCarriersListRows = createSelector(
  [selectCarriersListState],
  (state) => state.rows,
);

export const selectCarriersListTotal = createSelector(
  [selectCarriersListState],
  (state) => state.totalCarriers,
);

export const selectCarriersListSearch = createSelector(
  [selectCarriersListState],
  (state) => state.search,
);

export const selectCarriersListFromIndex = createSelector(
  [selectCarriersListState],
  (state) => state.fromIndex,
);

export const selectCarriersListLoading = createSelector(
  [selectCarriersListState],
  (state) => state.loading,
);

export const selectCarriersListError = createSelector(
  [selectCarriersListState],
  (state) => state.error,
);

export const selectCarriersListSortOrder = createSelector(
  [selectCarriersListState],
  (state) => state.sortingOrder,
);

export const selectCarriersListSortField = createSelector(
  [selectCarriersListState],
  (state) => state.sortingField,
);

export const selectCarriersListOperatorIds = createSelector(
  [selectCarriersListState],
  (state) => state.selectedOperatorIds,
);

export const selectCarriersListCustomerIds = createSelector(
  [selectCarriersListState],
  (state) => state.selectedCustomerIds,
);

export const selectCarriersListShowOnlyActive = createSelector(
  [selectCarriersListState],
  (state) => state.showOnlyActive,
);

export const selectCarriersListFilterDotStatus = createSelector(
  [selectCarriersListState],
  (state) => state.listFilterDotStatus,
);

export const selectCarriersListFilterRiskLevel = createSelector(
  [selectCarriersListState],
  (state) => state.listFilterRiskLevel,
);

export const selectCarriersListFilterAviroStatus = createSelector(
  [selectCarriersListState],
  (state) => state.listFilterAviroStatus,
);

export const selectCarriersListFilterLocationIds = createSelector(
  [selectCarriersListState],
  (state) => state.listFilterLocationIds,
);

export const selectCarriersListToolbarLocationFilterIds = createSelector(
  [selectCarriersListState],
  (state) => state.toolbarLocationFilterIds,
);
